import { EWatchlistFilter } from '@webtrader/core/api/market/watchlist';

export type TSymbolFilter = EMarketFilter | EWatchlistFilter;

export enum EMarketFilter {
  FOREX = 'FOREX',
  INDEX = 'INDEX',
  CRYPTO = 'CRYPTO',
  SHARES = 'SHARES',
  COMMODITIES = 'COMMS',
  FAVOURITES = 'FAVOURITES',
  OTHERS = 'OTHERS',
  ALL = 'ALL'
}
